import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "../Button";
import { cx } from "../utils";

interface TokenPaginationProps {
  currentPage: number;
  hasNextPage: boolean;
  onNextPage: () => void;
  onPreviousPage: () => void;
  className?: string;
}

const TokenPagination: React.FC<TokenPaginationProps> = ({
  currentPage,
  hasNextPage,
  onNextPage,
  onPreviousPage,
  className,
}) => {
  const hasPreviousPage = currentPage > 1;

  if (!hasPreviousPage && !hasNextPage) {
    return null;
  }

  return (
    <nav
      aria-label="Pagination"
      className={cx("mt-4 flex w-full", className)}
    >
      <div className="flex w-full items-center justify-between gap-2 px-2 py-1">
        <Button
          type="button"
          variant="ghost"
          disabled={!hasPreviousPage}
          onClick={onPreviousPage}
          aria-label="Previous page"
          className="h-8 gap-1.5 px-2 text-sm disabled:opacity-40"
        >
          <ChevronLeft className="size-4" aria-hidden="true" />
          <span>Back</span>
        </Button>
        <span
          className="min-w-16 px-3 py-1.5 text-center text-sm font-medium text-gray-700 dark:text-secondary"
          aria-current="page"
        >
          Page {currentPage}
        </span>
        <Button
          type="button"
          variant="ghost"
          disabled={!hasNextPage}
          onClick={onNextPage}
          aria-label="Next page"
          className="h-8 gap-1.5 px-2 text-sm disabled:opacity-40"
        >
          <span>Next</span>
          <ChevronRight className="size-4" aria-hidden="true" />
        </Button>
      </div>
    </nav>
  );
};

export default TokenPagination;
